import {atom} from 'recoil'

export const guideListAtom = atom({
  key: 'guideListAtom',
  default: []
})